import { useMutation } from "@tanstack/react-query";
import { apiClient, signApiRequest } from "./";
import type { CustomerCredentials } from "../ui/customerDataStore";

type InsurelyInput = {
  fid: string;
  collectionId?: string;
  company?: string;
  nationalId?: string;
  // Discovery log, should be removed
  event?: unknown;
};

const postInsurelyInput = async (
  payload: InsurelyInput,
  credentials: CustomerCredentials,
): Promise<InsurelyInput> => {
  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/mis/insurely-input`,
    credentials,
    { "content-type": "application/json" },
    payload,
  );
  const response = await apiClient(signedRequest);
  return response.data;
};

export const usePostInsurelyInput = (credentials: CustomerCredentials) =>
  useMutation<InsurelyInput, Error, InsurelyInput>({
    mutationFn: (payload) => postInsurelyInput(payload, credentials),
  });
